import { render, staticRenderFns } from "./KcRanking.vue?vue&type=template&id=20096a34&scoped=true&"
import script from "./KcRanking.vue?vue&type=script&lang=ts&"
export * from "./KcRanking.vue?vue&type=script&lang=ts&"
import style0 from "./KcRanking.vue?vue&type=style&index=0&id=20096a34&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20096a34",
  null
  
)

export default component.exports